import React from 'react';
import { SvgIcon } from '../../components/svgIcon';
import { SvgIconProps } from '../../components/svgIcon/model';

export const AppleIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="social/apple" ref={ref as any} {...props}>
      <path
        clipRule="evenodd"
        d="M16.3099 1C16.5036 2.31552 15.9682 3.6043 15.2618 4.51613C14.5061 5.49417 13.2035 6.25063 11.9414 6.21115C11.711 4.95166 12.3009 3.65397 13.0187 2.78162C13.806 1.81886 15.1555 1.08023 16.3099 1ZM20.1012 19.517C20.7519 18.5198 20.9949 18.0168 21.5 16.891C17.8264 15.494 17.2378 10.2714 20.8734 8.26689C19.7645 6.87624 18.2062 6.07011 16.7352 6.07011C15.6754 6.07011 14.9492 6.3467 14.289 6.59814C13.7388 6.80768 13.2345 6.99976 12.6212 6.99976C11.9583 6.99976 11.3713 6.7893 10.7567 6.56893C10.0814 6.32678 9.3726 6.07266 8.49314 6.07266C6.84244 6.07266 5.08541 7.08127 3.97144 8.80558C2.40555 11.2341 2.67265 15.7996 5.21199 19.6889C6.11963 21.0808 7.33233 22.6447 8.91847 22.6587C9.57662 22.6652 10.0146 22.4688 10.4885 22.2562C11.031 22.0129 11.6206 21.7485 12.6414 21.743C13.6683 21.7369 14.2486 22.0046 14.7838 22.2514C15.2456 22.4644 15.6738 22.662 16.3264 22.6549C17.9138 22.6421 19.1936 20.9089 20.1012 19.517Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
});
